import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type OnlineMeetingTranslations = {
  [lang: string]: Translation;
};

export const onlineMeetingTranslations: OnlineMeetingTranslations = {
  en,
};
